import { queryOptions } from '@tanstack/react-query'
import { listRecipes } from '../lib/api'

export const recipeKeys = {
	all: ['recipes'] as const,
	catalog: () => [...recipeKeys.all, 'catalog'] as const,
}

export const recipeCatalogQuery = () =>
	queryOptions({
		queryKey: recipeKeys.catalog(),
		queryFn: listRecipes,
		staleTime: 5 * 60 * 1000,
	})
